import { useDataBoxStatus } from 'app/common/data-box-store'

import { recipientsInfo } from '../dataBox'


export function useRecipientsInfoLoading() {
  const ready = useDataBoxStatus(recipientsInfo, () => recipientsInfo.ready)
  return !ready
}
